import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import TermsAndConditionsWeb from "./layouts/TermsAndConditions.web";
import TermsAndConditionsMob from "./layouts/TermsAndConditions.mob";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { FC } from "react";

const TermsAndConditionsComponent = withConditionalComponent(TermsAndConditionsWeb, TermsAndConditionsMob);

type Props = {
  termsAndCondition: string;
};

const TermsAndConditions: FC<Props> = ({ termsAndCondition }) => {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return <TermsAndConditionsComponent trigger={isLargeScreen} props={{ termsAndCondition }} />;
};

export default TermsAndConditions;
